import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class History extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>History - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
      		<h1>Explore Our Sugarmaster History</h1>
          <p>
            For four generations, the Patterson family has been producing maple syrup. 
            Around one hundred years ago, Orin Patterson tapped his first trees. The tapping tradition was
            carried on by Clifton Patterson. They produced enough syrup for their own use and trading necessities.
          </p>

          <p>
            When Orin was sugaring, there were no tractors or trucks.
            All the gathering was done by a team of horses and a lot of manual labor. Wooden spiles were whittled from Sumac or other
            woods with pithy centers. Holes were bore into the tree with a bit and a brace, and the spiles were driven into the hole.
            Wooden buckets were set under or hung from the spile to catch the sap. Sometimes three to four times a day, Orin
            and the family hitched Dobbin to the sled and traveled to the sugar bush to collect sap.
          </p>

          <p>
            Cornerstones of the old sugarhouse, where the entire family worked to boil the sap into syrup, can still be seen today.
            Wood was the only fuel, and it took more than a little to make syrup. Orin was in charge of the sugarhouse work, while Grandma
            was in charge of the kitchen where the cream, candy, and sugar were made.
          </p>

          <p>
            At that time, sugar was poured into molds that formed square blocks of sugar. White sugar was rarely used. 
            Instead, maple sugar was scraped off the block for all canning, baking, and cooking needs.
          </p>

          <p>
            When Clifton took over the farm, he continued to harvest sap in the same manner. However, he did keep up with the times. 
            The wooden spiles became iron, which then became cheaper ones made from tin. The wooden buckets became covered buckets of 
            galvanized steel, and a Farmall tractor replaced Dobbin. Clifton made a bit more syrup than Orin, but the same love 
            and care went into it.
          </p>

          <p>
            When Clifton retired, he sold the farm to Richard, who also loved sugaring. As time had went on, a lot of change had taken place. 
            The demand for maple has forced production to increase. A few buckets are still hung by the road, but it is now
            a world of hi-tech equipment, like plastic spiles, vinyl tubing, battery powered drills, reverse osmosis filters, and 
            stainless steel. A lot of TLC and pride continues to be required, even with this equipment. 
          </p>

          <p>
            We have one large 6' by 16' evaporator and two large reverse osmosis systems. The evaporator is made of 
            stainless steel pans that are turbo diesel fired,
            and it takes hundreds of thousands of gallons of sap to keep it supplied. Although we continue to tap the same trees
            that Orin did, we lease several additional sugar bushes, totaling over 80,000 taps.
          </p>

          <p>
            Every Spring, we hire several loyal people for tapping and boiling. The sugarhouse is very busy from November to April.
            Several times a season, the sap flows faster than it boils, and we boil around the clock to catch up. The coffee pot never
            gets a break during sugaring season, nor the camaraderie of good friends. 
          </p>

          <p>
            After the sap stops and everything is cleaned up, we continue the daily process of making various products from the syrup.
            We only jug our syrup or make certain products as needed. This ensures that all products are fresh and the taste remains consistent.
          </p>

          <p>
            We are very proud of our history and today's sugarhouse. In December of 2017, we lost the son Richard, but his legacy of a high quality product
            still laced with tender loving care will live on in his son and family. Together, Terri & Terry Patterson took over ownership as the 
            fourth generation sugar makers in Sabinsville, Pennsylvania. They continue to learn and forward the high tech business that Richard has grown, 
            and Richard's plans will continue on. A few of these plans have recently been put in place. One is a monitoring system that lets us see 
            when tanks are full and allow us to turn the pumps off right from the sugarhouse. Another is a full new sap silo configuration. 
            There are now three 12' x 20' CDL stainless steel sap silos. Each silo can hold 17,000 gallons. They can be fed from top or bottom, and the 
            bottom is both sloped for drainage and equipped with a washing system. Trucks will unload sap into the first silo, 
            where it will then run through a sand filter into the second silo.
            Filtering the sap before it runs through the RO will prolong the life of their membranes and prefilters. The third silo will 
            hold permeate from the RO for cleaning. 
          </p>


          <p>
            We here at Patterson Farms hope you enjoy your visit to our website, and welcome any <Link to="/Contact">comments</Link>.
          </p>
          <Row>
            <Col xs="5">
              <RichardPic src={require("../media/richardpicnew.jpg")}></RichardPic>
              <h4 style={{textAlign: "center", marginTop: "10px"}}>The Sugarmaster</h4>
            </Col>
            <Col xs="7" style={{display: "flex", alignItems: "center"}}>
              <SignaturePic src={require("../media/signature.png")}></SignaturePic>
            </Col>
          </Row>
          

        </InternalContainer>
      </FluidContainer>
		);
	}
}

const RichardPic = styled.img` 
  width: 100%;
  height: auto;
  max-width: 300px; 
  display: block; 
  margin: 0 auto;

`;
const SignaturePic = styled.img` 
  width: 100%; 
  height: auto; 
  max-height: 84px;
  max-width: 230px;
  display: block; 
`;

const FluidContainer = styled(Container)` padding: 30px 0 20px 0!important;  `;
const InternalContainer = styled(Container)` h1 {color: black!important;}  `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/History.js